import React from "react";
import AutomobileAssistanceImages from "../components/AutomobileAssistance/AutomobileAssistanceImages";
import { Box, Container, Typography } from "@mui/material";
import WhyAcrossAutoAssist from "../components/AutomobileAssistance/WhyAcrossAutoAssist";
import RSA from "../components/AutomobileAssistance/RSA";
import HowItWorks from "../components/AutomobileAssistance/HowItWorks.js";
import CustomerReviews from "../components/AutomobileAssistance/CustomerReviews";
import banner1 from "../assets/Banner/WebBanner/HD CAR IMAGE.png";
import Header from "../layout/Header";
import AutoMobileHeroSection from "../components/AutomobileAssistance/AutoMobileHeroSection";
import HeroSection from "../components/HeroSection";
import logo from "../assets/images/About/about-logo.png";
import BannerContent from "../components/BannerContent";
import FAQ from "../components/FAQ";
import NewsLetter from "../components/Home/NewsLetter";
import { IntroProductSection } from "../components/introProductSection";
import productImage from "../assets/images/Automobile/image.jpg";
import location from "../assets/images/Automobile/location.gif";
import contact from "../assets/images/Automobile/24-hour-support.gif";
import rsafleet from "../assets/images/Automobile/fleet-supervisor.gif";
import ASTONPHONE from "../assets/images/Automobile/AssistanceOnPhone.png";
import REPAIRONSITE from "../assets/images/Automobile/RepairOnsite.png";
import BTEYJUMP from "../assets/images/Automobile/BatteryJumpstart.png";
import BTEYSWAP from "../assets/images/Automobile/BatterySwap.png";
import KEYLOST from "../assets/images/Automobile/KeyLost.png";
import FLATTYRE from "../assets/images/Automobile/FlatTyre.png";
import FLATBEDTOWING from "../assets/images/Automobile/Towing.png";
import PCA from "../assets/images/Automobile/PCA.png";

const AutomotiveAssistance = () => {
  const FAQdata = [
    {
      question: "What does Across Assist’s Automobile Assurance cover?",
      answer:
        "Across Assist offers comprehensive support including roadside assistance (flat tyres, battery issues, towing), emergency medical help, accident coverage up to ₹15 Lakhs, extended warranty, and even concierge services like pick-up/drop and cyber assistance. Whether you drive a fuel or electric vehicle, we’ve got you covered.",
    },
    {
      question: "How do I request help during a breakdown or emergency?",
      answer:
        "Simply tap the service request button on our app or website. You’ll receive real-time WhatsApp updates, live technician tracking, and support from verified vehicle experts—all designed to get you back on the road quickly and safely.",
    },
    {
      question: "Is the service available across India?",
      answer:
        "Yes! Across Assist operates India’s largest RSA (Roadside Assistance) network, ensuring help is always within reach—whether you're in a metro city or a remote highway location.",
    },
    {
      question:
        "What makes Across Assist different from regular roadside assistance providers?",
      answer:
        "We go beyond basic help. Our platform blends smart automation with human expertise, offers one-tap claims, automated policy issuance, and includes benefits like Garage Cash, Extended Warranty, and Concierge Card services—making vehicle protection seamless and stress-free.",
    },
  ];

  // Refined feature points - with concise, value-focused description
  const points = [
    {
      icon: location,
      title: "21,000+ Pin Codes Served",
    },
    {
      icon: contact,
      title: "24×7 On-Call Support",
    },
    {
      icon: rsafleet,
      title: "India’s Largest RSA Fleet",
    },
  ];
  const propsData = {
    imageSrc: productImage,
    altText: "Automobile Assistance Across Assist",
    heading: "Automobile Assistance\nThat Goes\nBeyond the Breakdown", // Note: Use \n for line breaks in JSX
    description:
      "Whether it’s a flat tyre in the middle of nowhere, a stalled engine during rush hour, or post-accident support, our Automobile Assistance ensures you’re never alone. We blend human expertise with smart automation to give you the fastest, most reliable help, wherever the road takes you.",
    points,
  };

  const CARDS = [
    { icon: ASTONPHONE, title: "On-Call Assistance" },
    { icon: REPAIRONSITE, title: "Repair Onsite" },
    { icon: BTEYJUMP, title: "Battery Jumpstart" },
    { icon: BTEYSWAP, title: "Battery Swapping" },
    { icon: KEYLOST, title: "Key Lost/Retrieval" },
    { icon: FLATTYRE, title: "Flat-Tyre" },
    { icon: FLATBEDTOWING, title: "Flatbed Towing" },
    { icon: PCA, title: "Personal Accident Cover" },
  ];
  const propsRSAData = {
    heading: "Our Services",
    cards: CARDS,
  };
  return (
    <>
      <BannerContent
        bannerImage={banner1}
        title="Automobile Assurance "
        subtitle="Drive with confidence, coverage that moves with you."
        containerStyles={{ background: "none" }}
        bannerHeight="400px"
      />
      <IntroProductSection {...propsData} />
      {/* <HeroSection
        bannerImage={banner1}
        heading="Automotive Assistance"
        description="Across Assist redefines roadside and vehicle support with solutions designed not just to respond, but to empower. Whether it’s a flat tyre in the middle of nowhere, a stalled engine during rush hour, or post-accident support, our Automobile Assistance ensures you’re never alone. We blend human expertise with smart automation to give you the fastest, most reliable help—wherever the road takes you."
        image={logo}
        gradientBg="linear-gradient(268.53deg, #1363DF 28.18%, #000000 124.21%)"
        gradientOpacity={0.9}
      /> */}

      {/* <Box>
        <WhyAcrossAutoAssist />
      </Box> */}

      <Box>
        <RSA {...propsRSAData} />
      </Box>

      <div className="bg-[#fff6f1] ">
        <div className="container-fluid  mx-auto text-center">
          <HowItWorks />
        </div>
      </div>

      {/* <div className="bg-[#fff6f1] py-20">
        <div className="max-w-screen-lg mx-auto">
          <div className="text-center mb-4">
            <h4 className="text-[2.2rem] text-center md:text-[2.5rem] font-semibold">
              What Our Customers Say
            </h4>
          </div>
        </div>
      </div> */}
      <CustomerReviews />

      <FAQ
        FAQdata={FAQdata}
        sectionTitle="Frequently Asked Questions"
        sectionDescription="Find answers to the most common questions below. If you need more help, contact our support."
      />

      <NewsLetter />
    </>
  );
};

export default AutomotiveAssistance;
